class MulticolumnAccordions extends HTMLElement {
  constructor() {
    super();
    this.list = this.querySelector(".multicolumn-accordion .multicolumn-list");
    this.columns = this.list.querySelectorAll(".multicolumn-list__item");
    this.accordions = [...this.columns].map(column => {
      return {
        column,
        opener: column.querySelector('.js-summary'),
        content: column.querySelector('.accordion-content')
      }
    });
    this.handleResize = this.handleResize.bind(this);
    this.boundToggle = this.toggleAccordion.bind(this);
    this.boundClose = this.closeAccordion.bind(this);
    this.handleResize();
  }

  connectedCallback() {
    window.addEventListener('resize', this.handleResize);
    this.accordions.forEach(accordion => {
      accordion.opener.addEventListener("click", () => this.boundToggle(accordion));
    });
  }

  toggleAccordion(accordion) {
    const state = accordion.opener.getAttribute("aria-expanded");
    this.accordions.forEach(this.boundClose);
    accordion.opener.setAttribute("aria-expanded", state == "true" ? "false" : "true");
    if (state == "true") {
      accordion.opener.focus();
    } else  {
      let contentHeight = accordion.content.getBoundingClientRect().height;
      this.list.style = `--content-height: ${contentHeight}px`;
    }
  }

  closeAccordion(accordion) {
    accordion.opener.setAttribute("aria-expanded", "false");
  }

  handleResize() {
    let containerWidth = this.list.getBoundingClientRect().width;
    this.accordions.forEach(accordion => {
      let cardLeft = accordion.column.offsetLeft;
      accordion.content.style = `--content-width: ${containerWidth}px; --offset-left: -${cardLeft}px;`
    });
  }
}
customElements.define('multicolumn-accordions', MulticolumnAccordions);
